import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const IProposals = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="20"
            viewBox="0 0 15 20"
            fill="none"
          >
            <path
              d="M14.2188 19V4.49091L10.6285 1H1V19H14.2188Z"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              d="M14.2188 4.65625H10.8438V1.28125"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <line
              x1="0.75"
              y1="-0.75"
              x2="9.09375"
              y2="-0.75"
              transform="matrix(-1 0 0 1 12.5312 9.92383)"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <line
              x1="0.75"
              y1="-0.75"
              x2="9.09375"
              y2="-0.75"
              transform="matrix(-1 0 0 1 12.5312 13.0176)"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <line
              x1="0.75"
              y1="-0.75"
              x2="4.875"
              y2="-0.75"
              transform="matrix(-1 0 0 1 8.3125 16.1875)"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default IProposals;
